let counter = 0;
const PLAIN_CSS_ID_PREFIX = "react-use-plain-css-";
function resolveElementId(elementId) {
    if (!elementId) {
        return `${PLAIN_CSS_ID_PREFIX}${(counter++).toString(36)}`;
    }
    return elementId.startsWith(PLAIN_CSS_ID_PREFIX) ? elementId : `${PLAIN_CSS_ID_PREFIX}${elementId}`;
}
/**
 * Creates or updates a `<style skip-rucss>` element in `document.head`.
 *
 * @param elementId Optional stable suffix (`rcb-animate-css`) or full id (`react-use-plain-css-…`).
 *                  When omitted, a unique id is generated (pass the returned id on later updates).
 */ function injectPlainCss(css, elementId) {
    const id = resolveElementId(elementId);
    let element = document.getElementById(id);
    if (!element) {
        element = document.createElement("style");
        element.style.type = "text/css";
        element.id = id;
        element.setAttribute("skip-rucss", "true");
        document.getElementsByTagName("head")[0].appendChild(element);
    }
    element.innerHTML = css;
    return id;
}
export { injectPlainCss };
